// https://github.com/ngrx/example-app
// https://offering.solutions/blog/articles/2018/02/10/separating-state-into-angular-modules-with-ngrx/
// https://dev.to/this-is-angular/ngrx-tips-i-needed-in-the-beginning-4hno#create-reusable-reducers

import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { locationsSkeletonReducer } from '../../components/locations-skeleton/state/locations-skeleton-reducer';
import { mapReducer } from '../../components/locations-skeleton/map/state/map-reducers';
import { locationListReducer } from '../../components/locations-skeleton/location-list/state/location-list-reducers';
import { ccListReducer } from '../../components/locations-skeleton/cc-list/state/cc-list-reducers';
import { LocationsSkeletonState } from '../../components/locations-skeleton/state/locations-skeleton-state';
import { MapState } from '../../components/locations-skeleton/map/state/map-state';
import { LocationListState } from '../../components/locations-skeleton/location-list/state/location-list-state';
import { CCListState } from '../../components/locations-skeleton/cc-list/state/cc-list-state';

export interface LocationsFeatureState {
  skeleton: LocationsSkeletonState,
  map: MapState,
  locationList: LocationListState,
  ccList: CCListState
  // ...
}

export const reducers: ActionReducerMap<LocationsFeatureState> = {
  skeleton: locationsSkeletonReducer,
  map: mapReducer,
  locationList: locationListReducer,
  ccList: ccListReducer,
  // ...
};
